// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Rm5RJaCv9xhyX2lY9jI3 {
  margin-top: 25px;
  height: 34px;
}
`, "",{"version":3,"sources":["webpack://./src/components/event-definitions/event-definition-types/AggregationConditionExpression.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,YAAY;AACd","sourcesContent":[":local(.formControlNoLabel) {\n  margin-top: 25px;\n  height: 34px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"formControlNoLabel": `Rm5RJaCv9xhyX2lY9jI3`
};
export default ___CSS_LOADER_EXPORT___;
